module.exports = __webpack_public_path__ + "static/media/banner-itaucard_new.cf6bebe4.jpg";